import { render, staticRenderFns } from "./banksOpeningBalance.vue?vue&type=template&id=bfd6b4e8&scoped=true"
import script from "./banksOpeningBalance.vue?vue&type=script&lang=js"
export * from "./banksOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./banksOpeningBalance.vue?vue&type=style&index=0&id=bfd6b4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6b4e8",
  null
  
)

export default component.exports